<template>
  <section class="section reveal-section" id="voluntariado" ref="sectionRef">
    <div class="section-header">
      <span class="section-label">Sé Parte</span>
      <h2 class="section-title">Únete al Equipo</h2>
      <p class="section-subtitle">¿Tienes un don o profesión que quieres poner al servicio de Dios?</p>
    </div>
    <div class="volunteer-grid">
      <div class="volunteer-info">
        <h3>¿Por qué ser voluntario?</h3>
        <p>En Vision House creemos que cada persona tiene dones únicos dados por Dios. Ya seas psicólogo, diseñador, maestro o estudiante, hay un lugar para ti en nuestra misión.</p>
        <ul class="benefits-list">
          <li v-for="(benefit, i) in benefits" :key="i">
            <i class="fas fa-check-circle"></i>
            {{ benefit }}
          </li>
        </ul>
      </div>
      <form class="volunteer-form" @submit.prevent="handleSubmit">
        <div class="form-group"><label>Nombre Completo</label><input type="text" v-model="form.name" placeholder="Tu nombre completo" required></div>
        <div class="form-group"><label>WhatsApp</label><input type="tel" v-model="form.whatsapp" placeholder="+502 XXXX XXXX" required></div>
        <div class="form-group"><label>Correo Electrónico</label><input type="email" v-model="form.email" placeholder="tu@email.com" required></div>
        <div class="form-group">
          <label>Profesión o Habilidad</label>
          <select v-model="form.skill" required>
            <option value="">Selecciona una opción</option>
            <option>Psicología</option><option>Diseño / Multimedia</option><option>Enseñanza / Educación</option>
            <option>Música / Artes</option><option>Administración</option><option>Desarrollo Web / TI</option>
            <option>Medicina / Salud</option><option>Otra</option>
          </select>
        </div>
        <div class="form-group"><label>¿Por qué quieres ser parte de Vision House?</label><textarea v-model="form.message" placeholder="Cuéntanos tu motivación..." required></textarea></div>
        <ion-button expand="block" type="submit" class="donate-action" :disabled="submitting">
          <i v-if="!submitting" class="fas fa-paper-plane" style="margin-right:8px"></i>
          <i v-else class="fas fa-spinner fa-spin" style="margin-right:8px"></i>
          {{ submitting ? 'Enviando...' : 'Enviar Solicitud' }}
        </ion-button>
      </form>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { IonButton } from '@ionic/vue'
import { useScrollReveal, useToast } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()
const { showToast } = useToast()
onMounted(() => registerReveal(sectionRef.value))

const benefits = ref([
  'Desarrollo profesional en ambiente cristiano',
  'Red de contactos misioneros nacionales',
  'Certificación en áreas de capacitación',
  'Experiencia de campo en comunidades reales',
  'Mentoría espiritual personalizada'
])

const form = ref({ name: '', whatsapp: '', email: '', skill: '', message: '' })
const submitting = ref(false)

const handleSubmit = () => {
  submitting.value = true
  setTimeout(() => {
    showToast('¡Solicitud enviada! Te contactaremos pronto.', 'success')
    form.value = { name: '', whatsapp: '', email: '', skill: '', message: '' }
    submitting.value = false
  }, 1500)
}
</script>

<style scoped>
.volunteer-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 5rem; max-width: 1100px; margin: 0 auto; align-items: center; }
.volunteer-info h3 { font-size: 2.5rem; color: var(--vh-azul-profundo); margin-bottom: 1.2rem; }
.volunteer-info > p { color: #555; line-height: 1.9; margin-bottom: 2.5rem; font-size: 1.1rem; }
.benefits-list { list-style: none; }
.benefits-list li { padding: 1.2rem 0; border-bottom: 1px solid #eee; display: flex; align-items: center; gap: 1.2rem; color: #444; font-size: 1.05rem; transition: var(--vh-transicion); }
.benefits-list li:hover { padding-left: 10px; color: var(--vh-azul-profundo); }
.benefits-list li i { color: var(--vh-verde); font-size: 1.3rem; min-width: 24px; }
.volunteer-form { background: white; padding: 3rem; border-radius: 30px; box-shadow: 0 15px 50px var(--vh-sombra); border: 1px solid rgba(0,0,0,0.03); }
.form-group { margin-bottom: 1.8rem; }
.form-group label { display: block; margin-bottom: 0.6rem; font-weight: 700; color: var(--vh-azul-profundo); font-size: 0.9rem; text-transform: uppercase; letter-spacing: 0.5px; }
.form-group input, .form-group textarea, .form-group select { width: 100%; padding: 1.1rem; border: 2.5px solid #e8e8e8; border-radius: 14px; font-family: 'Open Sans', sans-serif; font-size: 1rem; transition: var(--vh-transicion); background: var(--vh-gris-piedra); }
.form-group input:focus, .form-group textarea:focus, .form-group select:focus { outline: none; border-color: var(--vh-azul-profundo); background: white; box-shadow: 0 0 0 5px rgba(26, 75, 140, 0.08); }
.form-group textarea { resize: vertical; min-height: 120px; }
.donate-action { --background: var(--vh-azul-profundo); --color: white; --border-radius: 50px; }

@media (max-width: 1024px) {
  .volunteer-grid { grid-template-columns: 1fr; gap: 3rem; }
}
@media (max-width: 768px) {
  .volunteer-form { padding: 2rem; }
}
</style>
